import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { availableDeliveryForInvoice, CreateInvoiceRequest, LoadInvoice, SearchAvailableDeliveriesForInvoiceRequest } from "src/app/domain/models/LoadInvoice";
import { PageResult } from "src/app/domain/models/PageResult";
import { Routes } from "src/app/infrastructure/routes";
import { LoadInvoiceGateway } from "../gateway/LoadInvoiceGateway";

@Injectable({providedIn: 'root'})
export class LoadInvoiceService  extends LoadInvoiceGateway {

constructor(private _http: HttpClient) {
    super()
  }

  getAvailableDeliveriesForInvoice(request: SearchAvailableDeliveriesForInvoiceRequest):
  Observable<PageResult<availableDeliveryForInvoice>>
  {
    return this._http.get<PageResult<availableDeliveryForInvoice>>(
      Routes.loadInvoiceApi + '/SearchAvailableDeliveries', { params: {...request} });
  }

  createInvoice(request: CreateInvoiceRequest): Observable<any> {
    return this._http.post<any>(Routes.loadInvoiceApi + '/Create', {...request});
  }

  getAllInvoicesByReference(referenceId: number, byProfile: boolean, pageNumber: number, pageSize: number): Observable<PageResult<LoadInvoice>> {
    return this._http.get<PageResult<LoadInvoice>>(
      Routes.loadInvoiceApi + '/GetAllByReference',
      { params: { referenceId, byProfile, pageNumber, pageSize } }
    );
  }

  deleteInvoice(invoiceId: number): Observable<any> {
    return this._http.delete<any>(Routes.loadInvoiceApi + `/Delete/`, { params: { invoiceId } });
  }

  downloadInvoiceExcel(invoiceId: number): Observable<Blob> {
    return this._http.get(
      Routes.loadInvoiceApi + `/DownloadInvoice/`,
      { responseType: 'blob', params: { invoiceId } }
    );
  }

}
